import {getFormPrivileges} from "../secure/secureManager";
import {PrivilegesCheckerPropsModel} from "../../models";

export const checkActionPrivilege  = (request:PrivilegesCheckerPropsModel):boolean => {
    if (!request.action) return true;
    const permissions = getFormPrivileges(request.formId);
    // In case the response doesn't contain info about form permissions
    if (!permissions) return true;
    return permissions[request.action];
};